import { request } from '@/utils/request'


// 获取消息列表接口
export const messageListAPi = (data) => {
  return request({
    url: '/cent-message/record/pageV2',
    method: 'post',
    data
  })
}

// 消息数量接口

export const messageAccountAPi = (data) => {
  return request({
    url: '/cent-message/record/count',
    method: 'post',
    data
  })
}

// 删除消息接口

export const messageDeleteApi = (params) => {
  return request({
    url: '/cent-message/record/delete',
    method: 'get',
    params
  })
}

// 已读状态转换-异步

export const readedApi = (data) => {
  return request({
    url: '/cent-message/read',
    method: 'post',
    data
  })
}
// 已读状态转换-同步
export const readedOneApi = (id) => {
  return request({
    url: `/cent-message/read-one?id=${id}`,
    method: 'get',
  })
}